export const PLAN_TYPES = {
  BASIC: 'BASIC_V2',
  PRO: 'PRO_V2',
  SMART: 'SMART',
  PREMIUM: 'PREMIUM'
}

export const PLAN_TYPES_DISPLAY = {
  'BASIC_V2': 'Basic',
  'PRO_V2': 'Pro',
  SMART: 'Smart',
  PREMIUM: 'Premium'
}

export const CreditCardImagesClasses = {
  BASIC: 'credit-card-standard',
  PRO: 'credit-card-pro',
  SMART: 'credit-card-pro',
  PREMIUM: 'credit-card-premium'
}

export const UBORoles = {
  PARTNER: 'PARTNER',
  PARTNER_FULL_ACCESS: 'PARTNER_FULL_ACCESS'
}

export const INSTITUTION_IDS_MAP = {
  CHOICE: 'b0c290e9-67e5-4973-b3e5-8b2720088ee7',
  SUNRISE: 'b0c290e9-67e5-4973-b3e5-8b2720088ee8'
}

export const BANK_TYPES = {
  SUNRISE: 'SUNRISE',
  CHOICE: 'CHOICE'
}
export const BANK_TYPE_IDS_MAP = {
  [INSTITUTION_IDS_MAP.CHOICE]: 'CHOICE',
  [INSTITUTION_IDS_MAP.SUNRISE]: 'SUNRISE'
}

export const ONBOARDING_STATUS = {
  DURING_REGISTRATION: 'DURING_REGISTRATION',
  KYC_PASSED: 'KYC_PASSED',
  KYC_FIRST_FAILED: 'KYC_FIRST_FAILED',
  KYC_FAILED_UPLOADED_DOCS: 'KYC_FAILED_UPLOADED_DOCS',
  KYB_PENDING: 'KYB_PENDING',
  COMPLETED: 'COMPLETED'
}

export const ONBOARDING_TYPE_ENUM = {
  STANDARD: 'STANDARD',
  MULTI_BUSINESS: 'MULTI_BUSINESS',
  NO_CONTINUE_BLOCK: 'NO_CONTINUE_BLOCK',
  NO_CONTINUE_PRIMARY: 'NO_CONTINUE_PRIMARY'
}

export const KYB_STATUS = {
  PENDING: 'PENDING',
  NEW: 'NEW',
  RESUBMIT: 'RESUBMIT'
}



// WEBPACK FOOTER //
// ./src/consts/index.js